<template>
    <div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
            ></forms-download-reprt>
        </div>
     <div class="filter-container">
        <div class="left-content">
         </div>
         <div class="right-content">
            <c-budget-forms-data-transfer
                    v-if="!isGkkpMode && !(progress < 100) && variantAttribute"
                    :header="header"
                    :lng="lng"
                    :getDataTransferText="getDataTransferText"
                    :getErrText="getErrText"
                    :makeToast="makeToast"
                    @reloadTable="loadDatas"
                />
             <div class="filter-actions filter-actions-flex">
                <c-budget-forms-copy-data
                    v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                    :budgetForm="budgetForm"
                    :header="header"
                    :isLoad="isLoad"
                    @keyPress="keyPress"
                />
                <b-button :style="{ 'minWidth': '110px' }" variant="primary" @click="onAddNewCat" v-if="variantAttribute" :disabled="isLoad || !areAllRequiredFieldsValid"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</b-button>
                <b-button :style="{ 'minWidth': '110px' }" variant="success" @click="prepareForSave" :disabled="isLoad || !variantAttribute || !hasChangedFields">{{ getCommonText('save') }}</b-button>
             </div>
         </div>
     </div>
        <b-overlay :show="isLoad" rounded="sm">

        <div class="table-container">
            <b-overlay :show="mainTableOverlay" rounded="sm">
            <b-table
                :fields="tableFields"
                :items="budgetForm"
                responsive="true"
                bordered
                head-variant="light"
                sticky-header="true"
                no-border-collapse
            >
                <template #top-row="data">
                    <td class="td-numbering"></td>
                    <td class="td-numbering table-success">1</td>
                    <td class="td-numbering table-danger">2</td>
                    <td class="td-numbering table-info">3</td>
                    <td class="td-numbering table-primary">4</td>
                    <td class="td-numbering table-warning">5</td>
                    <td class="td-numbering table-success">6</td>
                    <td colspan="2" class="td-numbering"></td>
                </template>
                <template #head(action)>
                    <div class="text-center">
                        <b-form-checkbox
                            v-model="selectAll"
                            @change="e => setIsAllDelete(e)"
                            :value="true"
                            :unchecked-value="false" />
                    </div>
                </template>
                <template #head(more)>
                    <div class="text-center">
                        <i
                            :title="getCommonText('del_selected')"
                            class="icon icon-close table-all-remove"
                            @click="deleteItemWithAttachedFiles(`${selectAll ? getDecText('del_all_recs') : getDecText('del_selected_recs')}`)"/>
                    </div>
                </template>
                <template #cell(action)="data">
                    <b-form-checkbox
                        v-model="data.item.itemToDelete"
                        @input="e => { if (!e) selectAll = false; }"
                        :value="true"
                        :unchecked-value="false" />
                </template>
                <template #cell(name)="data">
                    <div
                    class="column-width-100 bp-category-name">
                        <div>{{ data.item['name_' + lng] }} </div>
                        <i 
                            v-if="variantAttribute"
                            class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18" 
                            @click="onEditCatName(data.item)"
                        ></i>
                    </div>
                </template>
                <template #cell(amount)="data">
                    <b-form-input v-if="variantAttribute"
                                  class="text-right"
                                  v-model="data.item.amount"
                                  :disabled="nameIsEmpty(data.item, ['name_ru', 'name_kk'])"
                                  @keyup.enter.exact="keyup13"
                                  @keypress="keyPress($event, '^\\d*\\.?\\d{0,2}$')"
                                  @blur="inputFixed(data.item, 'amount', data.item.amount, 2, 0)"
                                  @input="markAsChanged(data.item)">
                    </b-form-input>
                    <div v-else>{{ $n(data.value) }}</div>
                    <p class="goods-form-val-msg" v-if="variantAttribute && !isFieldValid(data.item.amount)">{{ getCommonText("positive") }}</p>
                </template>
                <template #cell(cost)="data">
                    <b-form-input v-if="variantAttribute"
                                  class="text-right"
                                  v-model="data.item.cost"
                                  :disabled="nameIsEmpty(data.item, ['name_ru', 'name_kk'])"
                                  @keyup.enter.exact="keyup13"
                                  @keypress="keyPress($event, '^\\d*\\.?\\d{0,3}$')"
                                  @blur="inputFixed(data.item, 'cost', data.item.cost, 3, 0)"
                                  @input="markAsChanged(data.item)">
                    </b-form-input>
                    <div v-else>{{ $n(data.value) }}</div>
                    <p class="goods-form-val-msg" v-if="variantAttribute && !isFieldValid(data.item.cost)">{{ getCommonText("positive") }}</p>
                </template>
                <template #cell(justification)="data">
                    <div
                    class="column-width-100 bp-category-name">
                        <div>{{ data.item['justif_' + lng] || '' }} </div>
                        <i 
                            v-if="variantAttribute"
                            class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18" 
                            @click="onEditJustification(data.item)"
                        ></i>
                    </div>
                </template>
                <template #cell(total)="data">
                    <div class="text-right" style="min-width: 200px">{{ $n(data.value) }}</div>
                </template>
                <template #cell(files)="data">
                    <span
                        class="blue pointer underline"
                        @click="onFilesClick(data.item)"
                    >({{data.item.files}})</span>
                </template>
                <template #cell(more)="data">
                    <div class="text-center">
                        <i 
                            :title="getCommonText('del_rec')" 
                            class="icon icon-clear table-remove" 
                            v-if="variantAttribute" 
                            @click="deleteItemWithAttachedFiles(`${getCommonText('del_rec')}?`, data.item, data.index)"
                        ></i>
                    </div>
                </template>
                <template #bottom-row="data">
                    <td class="text-right" colspan="4">{{ getCommonText('total') }}</td>
                    <td class="text-right">{{ $n(total) }}</td>
                    <td colspan="3"></td>
                </template>
            </b-table>
            </b-overlay>
        </div>
        
        <div class="table-add" v-if="variantAttribute" :disabled="isLoad || !areAllRequiredFieldsValid">
            <span @click="onAddNewCat" :class="{'bf-disabled': isLoad || !areAllRequiredFieldsValid}"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</span>
        </div>
        </b-overlay>
        <files-updown v-if="isFilterReady" 
                      :header="header"
                      :variant-attribute="variantAttribute"
                      :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
                      :load="load"
                      @getFiles="getFiles"
                      @getNewFiles="getNewFiles($event)"
                      @delFile="delFile($event)"
                      @onFilePreview="onFilePreview"
                      ref="fileUpdown"
        ></files-updown>
        <modal-files-management-nodecode
            ref="modalFilesManagement"
            :variant-attribute="variantAttribute"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
            @fileUpload="fileUpload"
            @toggleIsAdd="toggleIsAdd($event)"
        />
        
        <c-set-b-f-category-name
            ref="setCatNameModal"
            :budgetForm="budgetForm"
            :categoryFieldNames="categoryFieldNames"
            :lng="lng"
            :maxNameLengthSymbls="500"
            :getCommonText="getCommonText"
            @addItem="addItem"
            @saveItem="onNameChanged"
        />
        <c-set-b-f-category-name
            ref="setJustificationModal"
            :budgetForm="budgetForm"
            :lng="lng"
            :getCommonText="getCommonText"
            :categoryFieldNames="justificationFieldNames"
            :maxNameLengthSymbls="500"
            :title="this.getFormText('justification')"
            :textareaTitleRu="this.getFormText('justification_title_ru')"
            :textareaTitleKk="this.getFormText('justification_title_kk')"
            :placeHolder="this.getFormText('justification_placeholder')"
            :canBeEmpty="true"
            :isDoublesCheckNeeded="false"
            @saveItem="updateJustification"
        />
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import ModalFilesManagementNodecode from '@/modules/budget-request/components/modal-files-management-nodecode.vue';
import FormsHandlerMixin1 from "../mixins/forms-handler-mixin-1";
import CBudgetFormsCopyData from '@/modules/budget-request/components/budget-forms-copy-data.vue';
import FormsDownloadReprt from "@/modules/budget-request/components/forms-download-reprt.vue";
import CSetBFCategoryName from "@/modules/budget-request/components/c-set-bf-category-name.vue";
import CBudgetFormsDataTransfer from '@/modules/budget-request/components/budget-forms-data-transfer.vue';

export default {
    name: 'Form165_v2',
    components: { 
        FilesUpdown, 
        BudgetFormsList, 
        FormsDownloadReprt, 
        ModalFilesManagementNodecode, 
        CBudgetFormsCopyData,
        CSetBFCategoryName,
        CBudgetFormsDataTransfer
    },
    mixins: [FormsHandlerMixin1],
    data() {
        return {
            defaultParams: {
                gr: 5,
                abp: 253,
                prg: 33,
                ppr: 46
            },
            form: {
                code: '165',
                version: '2',
                name_ru: 'Расчет расходов на исполнение исполнительных документов, судебных актов версия 2',
                name_kk: 'Атқару құжаттарын, сот актілерін орындау 2 нұсқасы',
                spf: {
                    name: '165-Расчет расходов на исполнение исполнительных документов, судебных актов версия 2',
                    spf: '165'
                }
            },
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            header: null,
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            row_files: [],
            isAdd: false,
            rowId: false,
            newRowStartId: -1,
            categoryFieldNames: {ru: "name_ru", kk: "name_kk"},
            justificationFieldNames: {ru: "justif_ru", kk: "justif_kk"}
        };
    },
    created() {
        this.$emit("setForm", this.form);
    },
    mounted() {
        this.progress = 15;
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        }
    },
    methods: {
        async loadSpecificData() {
            if (this.header) {
                this.$set(this.header, 'form_version', '165_v2');
            }
        },

        isFieldValid(value) {
            return value !== null && value !== '' && value > 0;
        },

        defineTotalProperty(item) {
            const that = this;
            Object.defineProperty(item, 'total', {
                get: function () {
                    const total = that.number(item.amount) * that.number(item.cost);
                    return parseFloat((Math.round(total * 1000) / 1000).toFixed(3));
                }
            });
        },

        markAsChanged(item) {
            if (item.id > 0) { // только для существующих записей
                item.isChanged = true;
            }
        },

        onNameChanged(item) {
            this.markAsChanged(item);
        },

        addItem(nameRu, nameKk) {
            const item = { 
                id: this.newRowStartId,
                name_ru: nameRu,
                name_kk: nameKk,
                justif_ru: '',
                justif_kk: '',
                isChanged: true
            };
            this.newRowStartId--;
            this.itemUpdate(item);
            this.defineTotalProperty(item);
            this.budgetForm.push(item);
        },

        async itemUpdate(item) {
            this.$set(item, 'amount', 0);
            this.$set(item, 'cost', 0);
            this.$set(item, 'files', 0);
            this.$set(item, 'itemToDelete', false);

            try {
                this.load = true;
                const response = await fetch(`/api-py/get-new-row-files-form/${item.id}/${JSON.stringify(this.header)}`);
                const emptyRowFiles = await response.json();
                this.$set(item, 'row_files', emptyRowFiles);
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} itemUpdate`, error.toString());
            }
            this.load = false;
        },

        number(value) {
            return (isNaN(parseFloat(value)) ? 0 : parseFloat(value));
        },

        getFiles(data) {
            this.files = data;
        },

        async loadDatas() {
            this.load = true;
            await this.budgetForm.splice(0);
            this.$set(this.header, 'form_version', this.form.code + '_v2')
            try {
                const response = await fetch('/api-py/get-budget-request-form-with-row-attach-files/' + JSON.stringify(this.header));
                const values = await response.json();

                await values.forEach(val => {
                    const item = {
                        id: val.id,
                        name_ru: val.name_ru,
                        name_kk: val.name_kk,
                        amount: val.amount,
                        cost: val.cost,
                        justif_ru: val.justif_ru || '',
                        justif_kk: val.justif_kk || '',
                        files: val.files,
                        row_files: val.row_files,
                        itemToDelete: false,
                        isChanged: false
                    };

                    this.defineTotalProperty(item);
                    this.budgetForm.push(item);
                });
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatas`, error.toString());
            }
            this.load = false;
        },

        onEditJustification(row) {
            const modal = this.$refs.setJustificationModal;
            if (modal) modal.showModal(row);
        },

        updateJustification(item) {
            this.markAsChanged(item);
        },

        toggleIsAdd(return_object) {
            const curBudgetForm = this.budgetForm.find(b => b.id === this.rowId)
            curBudgetForm['row_files'] = return_object['row_files']
            curBudgetForm['files'] = return_object['num_attach_files']
            this.isAdd = return_object['isAdd'];
            this.markAsChanged(curBudgetForm);
        },

        prepareForSave() {
            const values = [];
            for (const row of this.budgetForm) {
                if (this.isSavingForbidden(row, this.tableFields, ['amount', 'cost'], [])) return;
                if (!row.isChanged) continue;
                const item = Object.assign({}, this.header);
                this.$set(item, 'id', row.id);
                this.$set(item, 'name_ru', row.name_ru);
                this.$set(item, 'name_kk', row.name_kk);
                this.$set(item, 'amount', parseFloat(row.amount));
                this.$set(item, 'cost', parseFloat(row.cost));
                this.$set(item, 'justif_ru', row.justif_ru || '');
                this.$set(item, 'justif_kk', row.justif_kk || '');
                this.$set(item, 'row_files', row.row_files);

                values.push(item);
            }
            if (values.length > 0) {
                this.$bvModal.msgBoxConfirm(
                    this.getCommonText('on_save'),
                    {
                        title: this.getCommonText('confirm'),
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'success',
                        okTitle: this.getCommonText('yes'),
                        cancelTitle: this.getCommonText('cancel'),
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })
                    .then(value => {
                        if (value && this.variantAttribute) {
                            this.save(values);
                        }
                    })
                    .catch(error => {
                        this.makeToast('danger', this.getErrText('saving_error'), error.toString());
                    });
            }
        },

        async save(values) {
            this.isLoad = true;
            try {
                const data = {
                    values: values,
                    header: this.header,
                    total: this.total,
                };
                const response = await fetch("/api-py/save-brform165_v2/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(data),
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    this.loadDatas();
                    
                    if (this.files.length === 0) {
                        this.makeToast('warning', this.getErrText('warning'), this.getErrText('no_docs'));
                    }
                    this.makeToast('success', this.getErrText('msg'), this.getErrText('saved'));
                    this.deletingAgreementTotalResultHandler(result);
                } else {
                    throw this.getErrText('bad_data');
                }
            } catch (e) {
                this.makeToast('danger', this.getErrText('warning'), e.toString());
            } finally {
                this.isLoad = false;
            }
        },
    },
    computed: {
        total() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.total);
            }
            return Math.ceil(sum);
        },

        areAllRequiredFieldsValid() {
            return this.budgetForm.every(item => 
                this.isFieldValid(item.amount) && this.isFieldValid(item.cost)
            );
        },

        getFormText() {
            return this.setFormText('forms_v2_common.');
        },

        hasChangedFields() {
            const isChanged = this.budgetForm.find(itm => itm.isChanged);
            return !!isChanged;
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'name',
                        label: this.getCommonText('name')
                    },
                    {
                        key: 'amount',
                        label: this.getFormText('amount')
                    },
                    {
                        key: 'cost',
                        label: this.getFormText('unit_cost')
                    },
                    {
                        key: 'total',
                        label: this.getFormText('total_cost')
                    },
                    {
                        key: 'justification',
                        label: this.getFormText('justification')
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            };
            return [];
        },
    }
};
</script>
<style scoped>
    .goods-form-val-msg {
        font-size: 0.5rem;
        font-style: italic;
        color: red;
    }
    .filter-actions-flex {
        display: flex;
    }
    .bp-category-name {
        display: flex;
        justify-content: space-between;
    }
    .bp-category-name .icon-pencil-edit {
        align-self: center;
    }
    .bf-disabled {
        pointer-events: none; /* запретить клики */
        opacity: 0.5;         /* сделать бледным */
        cursor: not-allowed;  /* курсор "запрещено" */
    }
</style>